global.conmed = global.conmed || {};

/**
 * Moneris Card Storage Form Module
 * Handles Hosted Tokenization iframe communication, card vault storage, and multilingual support
 */
conmed.monerisPayment = function ($) {
    'use strict';

    var that = {
        selectors: {
            form: '.moneris-payment-form',
            submitBtn: '[id^="submitBtn-"]',
            iframe: '[id^="monerisFrame-"]',
            dataKey: '[id^="dataKey-"]',
            successMsg: '[id^="paymentSuccess-"]',
            errorMsg: '[id^="paymentError-"]',
            cardError: '[id^="cardError-"]',
            languageToggle: '[id^="languageToggle-"]'
        },
        currentLanguage: 'en'
    };

    /**
     * Translations dictionary for English and French
     */
    var translations = {
        en: {
            // Header
            formTitle: 'Credit Card Information',
            formSubtitle: 'Please enter your payment details below. All information is encrypted and secure.',

            // Contact Information
            contactInfo: 'Contact Information',
            accountName: 'Business Account Name *',
            accountNamePlaceholder: 'John Doe',
            email: 'Email *',
            emailPlaceholder: 'john.doe@example.com',
            phone: 'Phone *',
            phonePlaceholder: '(555) 123-4567',

            // Billing Address
            billingAddress: 'Billing Address',
            streetAddress: 'Street Address *',
            streetAddressPlaceholder: '123 Main Street',
            city: 'City *',
            cityPlaceholder: 'Toronto',
            province: 'Province *',
            selectProvince: 'Select',
            postalCode: 'Postal Code *',
            postalCodePlaceholder: 'A1A 1A1',

            // Province names (only ones that differ in French)
            province_BC: 'British Columbia',
            province_NB: 'New Brunswick',
            province_NL: 'Newfoundland and Labrador',
            province_NS: 'Nova Scotia',
            province_NT: 'Northwest Territories',
            province_PE: 'Prince Edward Island',
            province_QC: 'Quebec',

            // Credit Card
            creditCardInfo: 'Credit Card Info',
            cardNumber: 'Card Number (MC or Visa only)',
            expiryDate: 'Expiry Date',
            cvv: 'CVV',

            // Consent
            consent1: 'I acknowledge that CONMED Canada will securely store the above credit card information and payment can be processed using this information against any future outstanding Invoices.',
            consent2: 'I acknowledge that for each credit card transaction, a 1.5% processing fee will be added to the payment.',

            // Security
            securityTitle: 'Your credit card is secure',
            securityText: 'All credit card information is encrypted using industry-standard SSL technology. Your credit card details are never stored on our servers.',

            // Button
            submitButton: 'Submit Credit Card',
            processing: 'Processing...',

            // Messages
            successMessage: 'Your credit card information has been securely stored. Thank you!',
            referenceNumber: 'Reference Number',
            errorRequired: 'Please fill in all required fields and accept all agreements.',
            errorGeneral: 'An error occurred processing your request. Please check your information and try again, or contact your representative.'
        },
        fr: {
            // Header
            formTitle: "Formulaire d'autorisation de carte bancaire",
            formSubtitle: 'Veuillez entrer vos informations de paiement ci-dessous. Toutes les informations sont cryptées et sécurisées.',

            // Contact Information
            contactInfo: 'Vos coordonnées',
            accountName: "Nom du compte d'entreprise *",
            accountNamePlaceholder: 'Jean Dupont',
            email: 'Courriel *',
            emailPlaceholder: 'jean.dupont@exemple.com',
            phone: 'Téléphone *',
            phonePlaceholder: '(555) 123-4567',

            // Billing Address
            billingAddress: 'Adresse de facturation',
            streetAddress: 'Adresse *',
            streetAddressPlaceholder: '123 rue Principale',
            city: 'Ville *',
            cityPlaceholder: 'Toronto',
            province: 'Province *',
            selectProvince: 'Sélectionner',
            postalCode: 'Code postal *',
            postalCodePlaceholder: 'A1A 1A1',

            // Province names (French versions)
            province_BC: 'Colombie-Britannique',
            province_NB: 'Nouveau-Brunswick',
            province_NL: 'Terre-Neuve-et-Labrador',
            province_NS: 'Nouvelle-Écosse',
            province_NT: 'Territoires du Nord-Ouest',
            province_PE: 'Île-du-Prince-Édouard',
            province_QC: 'Québec',

            // Credit Card
            creditCardInfo: 'Renseignements sur la carte de crédit',
            cardNumber: 'Numéro de carte de crédit (MC ou Visa seulement)',
            expiryDate: "Date de péremption",
            cvv: 'Code de sécurité CVV',

            // Consent
            consent1: "Je reconnais que CONMED Canada conservera en toute sécurité les informations de carte de crédit ci-dessus et ces informations seront utilisées pour régler toute facture impayée à l'avenir.",
            consent2: "Je reconnais que pour chaque transaction par carte de crédit, des frais de traitement de 1,5% seront ajoutés au montant du paiement.",

            // Security
            securityTitle: 'Votre carte de crédit est sécurisée',
            securityText: "Toutes les informations de carte de crédit sont cryptées à l'aide de la technologie SSL standard de l'industrie. Les détails de votre carte de crédit ne sont jamais stockés sur nos serveurs.",

            // Button
            submitButton: 'Soumettre la carte de crédit',
            processing: 'Traitement en cours...',

            // Messages
            successMessage: 'Vos informations de carte de crédit ont été stockées en toute sécurité. Merci!',
            referenceNumber: 'Numéro de référence',
            errorRequired: 'Veuillez remplir tous les champs obligatoires et accepter tous les accords.',
            errorGeneral: "Une erreur s'est produite lors du traitement de votre demande. Veuillez vérifier vos informations et réessayer, ou contacter votre représentant."
        }
    };

    /**
     * Initialize payment forms on the page
     */
    that.init = function () {
        // Check if any payment forms exist
        if (!window.monerisPaymentForms || window.monerisPaymentForms.length === 0) {
            return;
        }

        // Initialize each payment form (new format: {id, iframeBaseUrl} or legacy string format)
        window.monerisPaymentForms.forEach(function (formConfig) {
            var formId = typeof formConfig === 'string' ? formConfig : formConfig.id;
            var iframeBaseUrl = typeof formConfig === 'object' ? formConfig.iframeBaseUrl : null;
            initializeForm(formId, iframeBaseUrl);
        });

        // Listen for Moneris postMessage responses
        window.addEventListener('message', handleMonerisResponse, false);
    };

    /**
     * Initialize a single payment form
     */
    function initializeForm(formId, iframeBaseUrl) {
        var $form = $('#paymentForm-' + formId);
        var $submitBtn = $('#submitBtn-' + formId);
        var $languageToggle = $('#languageToggle-' + formId);

        if ($form.length === 0) {
            return;
        }

        // Debug: Log initialization details
        var $iframe = $('#monerisFrame-' + formId);
        var iframeSrc = $iframe.attr('src');
        var profileIdMatch = iframeSrc ? iframeSrc.match(/[?&]id=([^&]+)/) : null;
        var profileId = profileIdMatch ? profileIdMatch[1] : 'NOT FOUND';

        console.log('[Moneris] Form initialized:', {
            formId: formId,
            profileId: profileId,
            iframeSrc: iframeSrc,
            useProduction: $('#useProduction-' + formId).val(),
            monerisOrigin: $('#monerisOrigin-' + formId).val()
        });

        // Store formId and iframe base URL on the form element for later reference
        $form.data('formId', formId);
        $form.data('iframeBaseUrl', iframeBaseUrl || $iframe.data('base-url') || iframeSrc);

        // Handle form submission
        $form.on('submit', function (e) {
            e.preventDefault();
            handleFormSubmit(formId);
        });

        // Handle language toggle
        if ($languageToggle.length > 0) {
            $languageToggle.on('click', '.lang-btn', function () {
                var $btn = $(this);
                var newLang = $btn.data('lang');

                // Update active state
                $languageToggle.find('.lang-btn').removeClass('active');
                $btn.addClass('active');

                switchLanguage(formId, newLang);
            });
        }

        // Update iframe with correct labels on initial load
        updateMonerisIframeLanguage(formId, that.currentLanguage);
    }

    /**
     * Switch the form language
     */
    function switchLanguage(formId, lang) {
        that.currentLanguage = lang;
        var $section = $('[data-form-id="' + formId + '"]');
        var t = translations[lang] || translations.en;

        console.log('[Moneris] Switching language to:', lang);

        // Update all elements with data-i18n attribute
        $section.find('[data-i18n]').each(function () {
            var $el = $(this);
            var key = $el.data('i18n');
            if (t[key]) {
                // For elements with SVG children, preserve the SVG
                var $svg = $el.find('svg').first();
                if ($svg.length > 0) {
                    var svgHtml = $svg.prop('outerHTML');
                    $el.html(svgHtml + ' ' + t[key]);
                } else {
                    $el.text(t[key]);
                }
            }
        });

        // Update all placeholders with data-i18n-placeholder attribute
        $section.find('[data-i18n-placeholder]').each(function () {
            var $el = $(this);
            var key = $el.data('i18n-placeholder');
            if (t[key]) {
                $el.attr('placeholder', t[key]);
            }
        });

        // Update Moneris iframe with translated labels
        updateMonerisIframeLanguage(formId, lang);
    }

    /**
     * Update Moneris iframe URL with translated labels
     */
    function updateMonerisIframeLanguage(formId, lang) {
        var $iframe = $('#monerisFrame-' + formId);
        var $form = $('#paymentForm-' + formId);
        var baseUrl = $form.data('iframeBaseUrl');

        if (!baseUrl) {
            console.warn('[Moneris] No base URL found for iframe');
            return;
        }

        var t = translations[lang] || translations.en;

        // Add translated labels to the URL
        console.log('[Moneris] Setting expiration label:', t.expiryDate);
        var labelParams = '&pan_label=' + encodeURIComponent(t.cardNumber) +
            '&exp_label=' + encodeURIComponent(t.expiryDate) +
            '&cvd_label=' + encodeURIComponent(t.cvv);

        var newUrl = baseUrl + labelParams;

        console.log('[Moneris] Updating iframe URL for language:', lang);
        console.log('[Moneris] Full iframe URL:', newUrl);
        console.log('[Moneris] exp_label encoded:', encodeURIComponent(t.expiryDate));
        $iframe.attr('src', newUrl);
    }

    /**
     * Handle form submission - first tokenize the card, then submit
     */
    function handleFormSubmit(formId) {
        var $form = $('#paymentForm-' + formId);
        var $submitBtn = $('#submitBtn-' + formId);

        // Clear previous errors
        hideError(formId);
        hideCardError(formId);

        // Validate form fields
        if (!validateForm(formId)) {
            return;
        }

        // Show loading state
        $submitBtn.addClass('loading').prop('disabled', true);

        // Store the current formId for the postMessage response
        window.currentMonerisFormId = formId;

        // Request token from Moneris iframe
        var $iframe = $('#monerisFrame-' + formId);
        var monerisOrigin = $('#monerisOrigin-' + formId).val();
        var iframeSrc = $iframe.attr('src');

        // Debug logging
        console.log('[Moneris] Tokenization request:', {
            formId: formId,
            monerisOrigin: monerisOrigin,
            iframeSrc: iframeSrc,
            targetUrl: monerisOrigin + '/HPPtoken/index.php',
            storeId: $('#storeId-' + formId).val(),
            useProduction: $('#useProduction-' + formId).val()
        });

        try {
            var iframeWindow = $iframe[0].contentWindow;
            console.log('[Moneris] Sending tokenize postMessage to:', monerisOrigin + '/HPPtoken/index.php');
            iframeWindow.postMessage('tokenize', monerisOrigin + '/HPPtoken/index.php');
        } catch (e) {
            console.error('[Moneris] Error communicating with iframe:', e);
            showError(formId, 'Unable to process card information. Please refresh and try again.');
            $submitBtn.removeClass('loading').prop('disabled', false);
        }
    }

    /**
     * Handle response from Moneris iframe
     */
    function handleMonerisResponse(e) {
        // Log all postMessage events for debugging
        console.log('[Moneris] postMessage received:', {
            origin: e.origin,
            data: e.data
        });

        // Verify origin is Moneris (supports both moneris.com and moneris.io domains)
        if (e.origin.indexOf('moneris.com') === -1 && e.origin.indexOf('moneris.io') === -1) {
            console.log('[Moneris] Ignoring message from non-Moneris origin:', e.origin);
            return;
        }

        var formId = window.currentMonerisFormId;
        if (!formId) {
            console.log('[Moneris] No active form ID, may be initial iframe load message');
            return;
        }

        var $submitBtn = $('#submitBtn-' + formId);
        var responseData;

        try {
            responseData = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
            console.log('[Moneris] Parsed response:', responseData);
        } catch (parseError) {
            console.error('[Moneris] Error parsing response:', parseError, 'Raw data:', e.data);
            showError(formId, 'Error processing card information. Please try again.');
            $submitBtn.removeClass('loading').prop('disabled', false);
            return;
        }

        // Log full response details
        console.log('[Moneris] Response details:', {
            responseCode: responseData.responseCode,
            dataKey: responseData.dataKey,
            errorMessage: responseData.errorMessage,
            fullResponse: JSON.stringify(responseData, null, 2)
        });

        // Check response code
        if (responseData.responseCode && responseData.responseCode[0] === '001') {
            // Success - store the token and submit the form
            console.log('[Moneris] Tokenization successful, dataKey:', responseData.dataKey);
            $('#dataKey-' + formId).val(responseData.dataKey);
            submitPayment(formId);
        } else {
            // Error - show error message
            console.error('[Moneris] Tokenization failed:', {
                responseCode: responseData.responseCode,
                errorMessage: responseData.errorMessage
            });
            var errorMsg = getCardErrorMessage(responseData.responseCode);
            showCardError(formId, errorMsg);
            $submitBtn.removeClass('loading').prop('disabled', false);
        }

        // Clear the current form ID
        window.currentMonerisFormId = null;
    }

    /**
     * Submit payment to backend
     */
    function submitPayment(formId) {
        var $form = $('#paymentForm-' + formId);
        var $submitBtn = $('#submitBtn-' + formId);
        var t = translations[that.currentLanguage] || translations.en;

        var data = {
            dataKey: $('#dataKey-' + formId).val(),
            cardholderName: $('#cardholderName-' + formId).val(),
            email: $('#email-' + formId).val(),
            phone: $('#phone-' + formId).val(),
            billingAddress: $('#billingAddress-' + formId).val(),
            billingCity: $('#billingCity-' + formId).val(),
            billingProvince: $('#billingProvince-' + formId).val(),
            billingPostalCode: $('#billingPostalCode-' + formId).val(),
            billingCountry: $('#billingCountry-' + formId).val(),
            checkbox1: $('#checkbox1-' + formId).is(':checked'),
            checkbox2: $('#checkbox2-' + formId).is(':checked'),
            storeId: $('#storeId-' + formId).val(),
            apiToken: $('#apiToken-' + formId).val(),
            useProduction: $('#useProduction-' + formId).val() === 'true',
            emailProfileName: $('#emailProfileName-' + formId).val() || null,
            language: that.currentLanguage,
            __RequestVerificationToken: $form.find('input[name="__RequestVerificationToken"]').val()
        };

        $.ajax({
            type: 'POST',
            url: '/StoreCardHandler.ashx',
            contentType: 'application/json',
            data: JSON.stringify(data),
            success: function (result) {
                $submitBtn.removeClass('loading').prop('disabled', false);

                if (result.Success) {
                    showSuccess(formId, result.TransactionId);
                    $form.hide();
                } else {
                    showError(formId, result.Message || t.errorGeneral);
                }
            },
            error: function (xhr, status, error) {
                console.error('Card storage error:', status, error);
                $submitBtn.removeClass('loading').prop('disabled', false);
                showError(formId, t.errorGeneral);
            }
        });
    }

    /**
     * Validate form fields
     */
    function validateForm(formId) {
        var isValid = true;
        var $form = $('#paymentForm-' + formId);
        var t = translations[that.currentLanguage] || translations.en;

        // Check required text fields
        var requiredFields = [
            'cardholderName', 'email', 'phone',
            'billingAddress', 'billingCity', 'billingProvince',
            'billingPostalCode'
        ];

        requiredFields.forEach(function (field) {
            var $field = $('#' + field + '-' + formId);
            var value = $field.val();

            if (!value || value.trim() === '') {
                $field.addClass('is-invalid');
                isValid = false;
            } else {
                $field.removeClass('is-invalid');
            }
        });

        // Validate email format
        var email = $('#email-' + formId).val();
        if (email && !isValidEmail(email)) {
            $('#email-' + formId).addClass('is-invalid');
            isValid = false;
        }

        // Check required checkboxes
        var checkboxes = ['checkbox1', 'checkbox2'];
        checkboxes.forEach(function (cb) {
            var $cb = $('#' + cb + '-' + formId);
            if ($cb.length > 0 && !$cb.is(':checked')) {
                $cb.addClass('is-invalid');
                isValid = false;
            } else if ($cb.length > 0) {
                $cb.removeClass('is-invalid');
            }
        });

        if (!isValid) {
            showError(formId, t.errorRequired);
        }

        return isValid;
    }

    /**
     * Validate email format
     */
    function isValidEmail(email) {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    /**
     * Get user-friendly error message for Moneris response codes
     */
    function getCardErrorMessage(responseCode) {
        var code = Array.isArray(responseCode) ? responseCode[0] : responseCode;

        var messages = {
            '940': 'Invalid profile configuration. Please contact support.',
            '941': 'Error generating token. Please try again.',
            '942': 'Invalid profile or security error. Please contact support.',
            '943': 'Invalid card number. Please check and try again.',
            '944': 'Invalid expiration date. Please use MM/YY format.',
            '945': 'Invalid CVV. Please check the 3 or 4 digit code.'
        };

        return messages[code] || 'Card validation failed. Please check your card details and try again.';
    }

    /**
     * Show success message with optional transaction ID
     */
    function showSuccess(formId, transactionId) {
        var $success = $('#paymentSuccess-' + formId);
        var t = translations[that.currentLanguage] || translations.en;

        // Add transaction ID if provided
        if (transactionId) {
            var $refContainer = $success.find('.reference-number');
            if ($refContainer.length > 0) {
                $refContainer.find('.ref-label').text(t.referenceNumber + ':');
                $refContainer.find('.ref-value').text(transactionId);
                $refContainer.removeClass('d-none');
            }
        }

        $success.removeClass('d-none');
    }

    /**
     * Show error message
     */
    function showError(formId, message) {
        var $error = $('#paymentError-' + formId);
        $('#errorMessage-' + formId).text(message);
        $error.removeClass('d-none');
    }

    /**
     * Hide error message
     */
    function hideError(formId) {
        var $error = $('#paymentError-' + formId);
        $error.addClass('d-none');
    }

    /**
     * Show card-specific error
     */
    function showCardError(formId, message) {
        var $cardError = $('#cardError-' + formId);
        $cardError.text(message).removeClass('d-none');
    }

    /**
     * Hide card-specific error
     */
    function hideCardError(formId) {
        var $cardError = $('#cardError-' + formId);
        $cardError.addClass('d-none');
    }

    return that;
}(jQuery);
